import { render, staticRenderFns } from "./equshow.vue?vue&type=template&id=9d6c541e&scoped=true&"
import script from "./equshow.vue?vue&type=script&lang=js&"
export * from "./equshow.vue?vue&type=script&lang=js&"
import style0 from "./equshow.vue?vue&type=style&index=0&id=9d6c541e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6c541e",
  null
  
)

export default component.exports